"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.URLParamsKeys = exports.StorageKeys = void 0;
let StorageKeys;
exports.StorageKeys = StorageKeys;

(function (StorageKeys) {
  StorageKeys["token"] = "api::l_t";
  StorageKeys["scope"] = "api::l_s";
})(StorageKeys || (exports.StorageKeys = StorageKeys = {}));

let URLParamsKeys;
exports.URLParamsKeys = URLParamsKeys;

(function (URLParamsKeys) {
  URLParamsKeys["token"] = "t";
  URLParamsKeys["scope"] = "scope";
})(URLParamsKeys || (exports.URLParamsKeys = URLParamsKeys = {}));